import PERFIL from '@/constants/perfil'

export const MENUS = {

  /* RECEPTOR */
  [PERFIL.RECEPTOR.RECEPTOR.codigo]: [
    {
      isItemMenu: true,
      nome: 'Upload de cadastros',
      icon: 'fa-upload',
      routeName: 'receptor/upload',
      routeGroup: 'UPLOAD'
    },
    {
      isItemMenu: true,
      nome: 'Processos',
      icon: 'fa-file-search',
      routeName: 'receptor/listagem',
      routeGroup: 'RECEPTOR_INFO_CADASTRO',
      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastroReceptor',
          icon: 'fa-file-chart-line',
          routeGroup: 'RECEPTOR_INFO_CADASTRO',
          parentRouteGroup: 'LISTAGEM'
        }
      ]
    }
  ],

  /* CENTRAL */
  [PERFIL.CENTRAL_DO_INTERESSADO.EXTERNO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Central de comunicações',
      icon: 'fa-comments',
      routeName: 'central/comunicacao',
      routeGroup: 'CENTRAL_COMUNICACAO',

      // Atributos para menu por cards
      codigo: 'CENTRAL_COMUNICACAO',
      img: 'CentralDeComunicacao.png'
    },
    {
      isItemMenu: true,
      nome: 'Consultar processos existentes',
      icon: 'fa-file-search',
      routeName: 'central/processos',
      routeGroup: 'CENTRAL_PROCESSOS',

      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastro',
          icon: 'fa-file-chart-line',
          routeGroup: 'CENTRAL_INFO_CADASTRO',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Central de mensagens',
          routeName: 'caixa-entrada',
          icon: 'fa-envelope',
          routeGroup: 'CENTRAL_MENSAGENS',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Gerenciamento de DAEs',
          routeName: 'gerenciamento-daes',
          icon: 'fa-dollar-sign',
          routeGroup: 'CENTRAL_DAES',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        }
      ],

      // Atributos para menu por cards
      codigo: 'PROCESSOS_EXISTENTES',
      img: 'processosExistentes.png'
    },
    {
      isItemMenu: true,
      nome: 'Solicitar Informação',
      icon: 'fa-info-circle',
      routeName: 'listagem/informacoes',
      routeGroup: 'CENTRAL_SOLICITAR_INFORMACOES',

      // Atributos para menu por cards
      codigo: 'SOLICITAR_INFORMACAO',
      img: 'informacao.png'
    },
    {
      isItemMenu: true,
      nome: 'Solicitar Resgate de Aforamento',
      icon: 'fa-mountains',
      routeName: 'listagem/aforamento',
      routeGroup: 'CENTRAL_AFORAMENTO',

      // Atributos para menu por cards
      codigo: 'RESGATE_AFORAMENTO',
      img: 'resgateAforamento.png'
    },
    {
      isItemMenu: true,
      nome: 'Vincular Vistoriador Credenciado',
      icon: 'fa-user-check',
      routeName: 'listagem/credenciado',
      routeGroup: 'CENTRAL_VISTORIADOR_CREDENCIADO',

      // Atributos para menu por cards
      codigo: 'INCLUIR_VISTORIADOR',
      img: 'vincular_credenciado.svg'
    },
    {
      isItemMenu: true,
      nome: 'Conflitos',
      icon: 'fa-file-alt',
      routeName: 'central/conflitos',
      routeGroup: 'CENTRAL_CONFLITOS',

      // Atributos para menu por cards
      codigo: 'CENTRAL_CONFLITOS',
      img: 'CentralDeComunicacao.png'
    }
  ],

  [PERFIL.CENTRAL_DO_INTERESSADO.PREFEITURA.codigo]: [
    {
      isItemMenu: true,
      nome: 'Consultar processos existentes',
      icon: 'fa-file-search',
      routeName: 'central/processos',
      routeGroup: 'CENTRAL_PROCESSOS',

      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastro',
          icon: 'fa-file-chart-line',
          routeGroup: 'CENTRAL_INFO_CADASTRO',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Central de mensagens',
          routeName: 'caixa-entrada',
          icon: 'fa-envelope',
          routeGroup: 'CENTRAL_MENSAGENS',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Gerenciamento de DAEs',
          routeName: 'gerenciamento-daes',
          icon: 'fa-dollar-sign',
          routeGroup: 'CENTRAL_DAES',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        }
      ],

      // Atributos para menu por cards
      codigo: 'PROCESSOS_EXISTENTES',
      img: 'processosExistentes.png'
    },
    {
      isItemMenu: true,
      nome: 'Solicitar informação',
      icon: 'fa-info-circle',
      routeName: 'listagem/informacoes',
      routeGroup: 'CENTRAL_SOLICITAR_INFORMACOES',

      // Atributos para menu por cards
      codigo: 'SOLICITAR_INFORMACAO',
      img: 'informacao.png'
    }
  ],

  /* ASSINATURA */
  [PERFIL.ASSINATURA.ASSINADOR.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'assinatura/home',
      routeGroup: 'ASSINATURA_CAIXA_DE_ENTRADA'
    },
    {
      isItemMenu: true,
      nome: 'Documentos assinados',
      icon: 'fa-pen',
      routeName: 'assinatura/documentosAssinados',
      routeGroup: 'ASSINATURA_DOCUMENTOS_ASSINADOS'
    }
  ],

  /* RELATORIOS */
  [PERFIL.RELATORIOS.RELATORIOS.codigo]: [
    {
      isItemMenu: true,
      nome: 'Relatórios Gerais',
      icon: 'fa-file-alt',
      routeName: 'relatorios/gerais',
      routeGroup: 'RELATORIOS',

      // Atributos para menu por cards
      codigo: 'RELATORIOS',
      img: 'RelatorioGeral.png'
    },
    {
      isItemMenu: true,
      nome: 'Relatórios de OS',
      icon: 'fa-info-circle',
      routeName: 'relatorios/os',
      routeGroup: 'RELATORIOS',

      // Atributos para menu por cards
      codigo: 'RELATORIOS_OS',
      img: 'RelatorioOS.png'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/pa/menu.js